import { navigationRef } from '@helpers';
import { OPERATOR_PANEL_INFORMATION_SCREENS } from '@components/operatorPanel/constants/operatorPanel.constants';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { FullNCFileViewDetailsScreenName, REPLACEMENT_PART_FOR_DETAILS_NAVIGATION_LOGIC } from '@v2/pages/common/constants/base.constants';
import { JobDetailsScreenName } from '@v2/pages/job/navigation/config';
import { NCFileDetailsScreenName } from '@v2/pages/nc-file/details/navigation/config';
import { PartDetailsScreenName } from '@v2/pages/part/details/navigation/config';
import { ProductionOrderDetailsScreenName } from '@v2/pages/productionOrder/navigation/config';
import { ToolsDetailsScreenName } from '@v2/pages/tools/details/navigation/config';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { MACHINES_MAIN_SCREEN } from '@v2/pages/machines/navigation/config';

export const useNavigationCheck = () => {
  const currentRoute = navigationRef?.current?.getCurrentRoute();

  // const safeIsNowSubScreenCheck = [MachinesScreen.LIVE, ...Object.values(NowSubScreen)].some((nowScreen) => currentRoute?.name?.includes(nowScreen));

  const safeIsNowSubScreenCheck = currentRoute?.name?.includes(MachinesScreen.LIVE);

  const safeIsMachinesScreenCheck = currentRoute?.name?.includes(MACHINES_MAIN_SCREEN) || safeIsNowSubScreenCheck;

  const detailsScreensRootNames = [
    NCFileDetailsScreenName,
    BatchDetailsScreenName,
    PartDetailsScreenName,
    ToolsDetailsScreenName,
    JobDetailsScreenName,
    ProductionOrderDetailsScreenName,
    FullNCFileViewDetailsScreenName,
  ];

  const safeIsDetailsScreen =
    currentRoute &&
    detailsScreensRootNames.some((matcher) => currentRoute?.name.includes(matcher.replace(REPLACEMENT_PART_FOR_DETAILS_NAVIGATION_LOGIC, '')));

  const safeIsOperatorPanelInfoScreen =
    currentRoute?.name === 'OperatorPanel' ||
    Object.values(OPERATOR_PANEL_INFORMATION_SCREENS).some((screenName: string) => currentRoute?.name?.includes(screenName));

  return { safeIsMachinesScreenCheck, safeIsDetailsScreen, safeIsNowSubScreenCheck, safeIsOperatorPanelInfoScreen };
};
